import React, { Component } from "react"
import { Card, Icon, Form, Button } from "semantic-ui-react"
import firebase from "../config/firebaseConfig"
import InputMask from "react-input-mask"
import { withTranslation } from "react-i18next"

@withTranslation()
class EmployeeCardForm extends Component {
  state = {
    disable: true,
    kostyl: true,
    old: { ...this.props.editedData },
  }
  componentDidMount() {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("captcha", {
      size: "invisible",
    })
  }

  componentDidUpdate(prevProps) {
    /* if (prevProps.editedData !== this.props.editedData) {
      this.setState({
        disable: false,
      })
    }
    if (prevProps.step !== this.props.step) {
      this.setState({
        disable: true,
      })
    } */
    if (
      this.props.editedData.login !== this.state.old.login ||
      this.props.editedData.phone !== this.state.old.phone ||
      this.props.editedData.lastName !== this.state.old.lastName ||
      this.props.editedData.firstName !== this.state.old.firstName ||
      this.props.editedData.middleName !== this.state.old.middleName ||
      !this.equalRoles()
    ) {
      if (this.state.disable) {
        this.setState({
          disable: false,
        })
      }
    }
    if (
      this.props.editedData.login === this.state.old.login &&
      this.props.editedData.phone === this.state.old.phone &&
      this.props.editedData.lastName === this.state.old.lastName &&
      this.props.editedData.firstName === this.state.old.firstName &&
      this.props.editedData.middleName === this.state.old.middleName &&
      this.equalRoles()
    ) {
      if (!this.state.disable) {
        this.setState({
          disable: true,
        })
      }
    }
  }

  equalRoles = () => {
    let b = true
    const oldRolles = { ...this.state.old.roles }
    const newRolles = { ...this.props.editedData.roles }
    if (newRolles.length !== oldRolles.length) {
      b = false
    } else {
      for (let i in oldRolles) {
        for (let j in newRolles) {
          if (i !== j) {
            b = false
          }
        }
      }
    }
    return b
  }

  equalStores = () => {
    let b = true
    const oldStores = { ...this.state.old.stores }
    const newStores = { ...this.props.editedData.stores }
    if (newStores.length !== oldStores.length) {
      b = false
    } else {
      for (let i in oldStores) {
        for (let j in newStores) {
          if (i !== j) {
            b = false
          }
        }
      }
    }
    return b
  }

  render() {
    const { t } = this.props
    return (
      <>
        <Card.Content key="1">
          <Form>
            <InputMask
              mask="999999999999"
              value={this.props.editedData.login || ""}
              onChange={(e) => {
                this.props.onChange(e)
              }}
              // disabled={!this.props.createEmployee}
              maskChar=""
            >
              {(inputProps) => (
                <Form.Input
                  {...inputProps}
                  label={t("UIN")}
                  type="text"
                  name="login"
                  error={
                    this.props.editedData.login &&
                    this.props.editedData.login.length !== 12
                  }
                  icon={
                    this.props.editedData.login &&
                    (this.props.editedData.login.length === 12 ? (
                      <Icon name="check" color="green" />
                    ) : (
                      <Icon name="x" color="red" />
                    ))
                  }
                />
              )}
            </InputMask>
            {/* <Form.Input
            label="Пароль"
            type="password"
            name="pass"
            value={pass || ""}
            onChange={this.onChange}
          /> */}
            <Form.Input
              label={t("lastname")}
              type="text"
              name="lastName"
              value={this.props.editedData.lastName || ""}
              onChange={this.props.onChange}
            />
            <Form.Input
              label={t("firstname")}
              type="text"
              name="firstName"
              value={this.props.editedData.firstName || ""}
              onChange={this.props.onChange}
            />
            <Form.Input
              label={t("middlename")}
              type="text"
              name="middleName"
              value={this.props.editedData.middleName || ""}
              onChange={this.props.onChange}
            />
            <div>
              <InputMask
                mask="+7\ 999 999 99 99"
                value={this.props.editedData.phone || "+7"}
                onChange={(e) => {
                  this.props.onChange(e)
                }}
                maskChar=""
              >
                {(inputProps) => (
                  <Form.Input
                    {...inputProps}
                    label={t("phoneNumber")}
                    name="phone"
                    type="text"
                    style={{ width: "65%", float: "left" }}
                  />
                )}
              </InputMask>
            </div>
            <div>
              <Button
                color="green"
                content={t("sendPassword")}
                id="captcha"
                style={{
                  width: "30%",
                  float: "right",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={this.props.sendNumber}
                disabled={
                  this.props.editedData.phone === undefined ||
                  (this.props.editedData.phone &&
                    this.props.editedData.phone.length !== 16)
                }
              ></Button>
            </div>
            {this.props.step ? (
              <>
                <Form.Input
                  label="Пароль"
                  type="password"
                  name="pass"
                  loading={this.props.loading}
                  icon={this.props.icon && <Icon name="check" color="green" />}
                  value={this.props.editedData.pass || ""}
                  onChange={this.props.onChange}
                />
                <p
                  style={{
                    fontSize: "13px",
                    marginTop: "-15px",
                    color: "grey",
                  }}
                >
                  * {t("Password was sent to the specified number")}
                </p>
              </>
            ) : null}
            {/* <Form.Input
                label="Подтвердить пароль"
                type="password"
                name="pass2"
                value={pass2 || ""}
                onChange={this.onChange}
                error={pass !== pass2}
              /> */}
            {/* <Form.Input
              label="Номер телефона"
              type="text"
              name="phone"
              value={this.props.editedData.phone || ""}
              onChange={this.props.onChange}
            /> */}
            <Form.Select
              options={this.props.roleOptions}
              multiple
              label={t("roles")}
              name="roles"
              value={this.props.editedData.roles}
              onChange={this.props.onRolesAndStoresChange}
            />
            <Form.Select
              options={this.props.storeOptions}
              multiple
              label={t("stores")}
              name="stores"
              value={this.props.editedData.stores}
              onChange={this.props.onRolesAndStoresChange}
            />
          </Form>
        </Card.Content>
        {this.props.createEmployee ? (
          <Card.Content key="2" extra>
            <Button
              color="green"
              onClick={this.props.onCreate}
              disabled={!this.props.icon}
            >
              {t("create")}
            </Button>
            <Button basic onClick={this.props.cancelCreating}>
              {t("delete")}
            </Button>
          </Card.Content>
        ) : (
          <Card.Content key="2" extra>
            <Button
              color="green"
              onClick={this.props.onSave}
              disabled={
                (this.state.disable &&
                  this.state.old.phone === this.props.editedData.phone) ||
                (this.state.old.phone !== this.props.editedData.phone &&
                  !this.props.icon)
              }
            >
              {t("save")}
            </Button>
            <Button basic onClick={this.props.cancelEditing}>
              {t("cancel")}
            </Button>
            <Button
              basic={!this.props.deleteClicked}
              color="red"
              data={this.props.employeeId}
              floated="right"
              onClick={this.props.onDelete}
            >
              {this.props.deleteClicked ? t("confirmDelete") : t("delete")}
            </Button>
          </Card.Content>
        )}
      </>
    )
  }
}

export default EmployeeCardForm
